<template>
  <fts-popper
    content-class="color-picker-dropdown"
    @select="selectOption"
  >
    <template #content="{ select }">
      <div class="color-picker-container" :style="getContainerWidth">
        <div
          v-for="(x, ind) in colors"
          :key="`${x}-${ind}`"
          class="color-picker-option"
          :style="getSelectionStyle(x)"
          @click="select(x)"
        >
          <div class="color-picker-remove" v-if="!x"></div>
        </div>
      </div>
    </template>
    <div class="color-picker-toggle" slot="reference">
      <slot>
        <div :style="getToggleStyle"></div>
      </slot>
    </div>
  </fts-popper>
</template>

<script>
import FTSPopper from './FTSPopperNew';

export default {
  components: {
    'fts-popper': FTSPopper
  },
  props: {
    colors: Array,
    value: String,
    toggleSize: {
      type: Number,
      default: 24,
    },
    optionSize: {
      type: Number,
      default: 24
    },
    rowLength: {
      type: Number,
      default: 6
    }
  },
  model: {
    prop: "value",
    event: "updateValue",
  },
  methods: {
    getSelectionStyle(option) {
      return {
        'width': `${this.optionSize}px`,
        'height': `${this.optionSize}px`,
        'border': `1px solid ${option || 'var(--fts-border)'}`,
        'border-radius': '10em',
        'background-color': option,
      };
    },
    selectOption(val) {
      this.$emit('updateValue', val);
      this.$emit('input', val);
    }
  },
  computed: {
    getToggleStyle() {
      return {
        'width': `${this.toggleSize}px`,
        'height': `${this.toggleSize}px`,
        'border': `1px solid ${this.value || 'var(--fts-border)'}`,
        'border-radius': '10em',
        'background-color': this.value,
      };
    },
    getContainerWidth() {
      return {
        width: `${(this.rowLength * this.optionSize) + (this.rowLength * 6)}px`
      }
    }
  }
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.color-picker-toggle {
  cursor: pointer;
}
.color-picker-dropdown {
  padding: 0.5rem;
}
.color-picker-container {
  @include flex-gap($gap: 6px);
}
.color-picker-option {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  .color-picker-remove {
    height: 75%;
    width: 75%;
    background: linear-gradient(to top right,transparent 0,transparent calc(50% - 2.4px),var(--fts-danger) 50%,transparent calc(50% + 2.4px),transparent);
  }
}
</style>